import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, computed } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

import { AuthService } from '@core/auth';
import { Enums, IEnums } from 'app/app.enums';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterModule, MatMenuModule, MatButtonModule, MatIconModule, MatDividerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  readonly enums: IEnums = Enums;

  // Computed signal from auth service
  readonly currentUser = computed(() => this.authService.currentUser());

  editProfile(): void {
    const user = this.currentUser();
    if (user?.userId) {
      void this.router.navigate(['/users', user.userId]);
    }
  }

  isInRole(roleName: string): boolean {
    if (roleName === '*') {
      return true;
    }
    const user = this.currentUser();
    return (user?.roles?.filter((r) => r.name === roleName)?.length ?? 0) > 0;
  }

  logout(): void {
    this.authService.logOut();
  }
}
